var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import ShoppingManageService from '../../../../../api/ShoppingManageService';
var default_1 = (function (_super) {
    __extends(default_1, _super);
    function default_1() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.categoryList = [];
        return _this;
    }
    default_1.prototype.created = function () {
        this.service = ShoppingManageService.getInstance();
    };
    default_1.prototype.mounted = function () {
        this.loadCategory();
    };
    default_1.prototype.loadCategory = function () {
        var _this = this;
        this.service.decorationCategory({
            is_all: 1
        }).then(function (res) {
            var data = Array.isArray(res.data.data) ? res.data.data : [];
            var newData = data.slice(0, 8);
            _this.categoryList = newData;
        }).catch(function (err) {
            _this.$message.error(err.message || err.msg);
        });
    };
    __decorate([
        Prop({
            type: String
        })
    ], default_1.prototype, "customClass", void 0);
    default_1 = __decorate([
        Component
    ], default_1);
    return default_1;
}(Vue));
export default default_1;
